import { DraggableProvided } from "@hello-pangea/dnd";
import { APIScope, InheritanceStatus, QuestInterface, QuestType } from "@swivl-mono/types";
import { Button, ButtonColor, Input, Spinner } from "@swivl-mono/ui";
import React from "react";
import { BiDotsVerticalRounded } from "react-icons/bi";
import { useNavigate } from "react-router-dom";

import { useHasPermission } from "../../../../../Helpers/Permissions/useHasPermission";
import { Member } from "../../../../../Models/Member/Member.Current";
import { QuestsModel } from "../../../../../Models/Quests/Quests.Model";
import "./BoardQuestItem.scss";
import { BoardQuestItemOverflowMenu } from "./Components/BoardQuestItemOverflowMenu";

interface Props {
  quest: QuestInterface;
  isDragging?: boolean;
  provided?: DraggableProvided;
  index?: number;
}

function BoardQuestItem(props: Props) {
  const { quest, isDragging, provided, index } = props;
  const [showMenu, setShowMenu] = React.useState(false);
  const [isEditing, setIsEditing] = React.useState(false);
  const [isSaving, setIsSaving] = React.useState(false);
  const [newName, setNewName] = React.useState(quest.name);
  const navigate = useNavigate();
  const canEditWorkflows = useHasPermission(APIScope.WORKFLOWS_EDIT);

  let tagColor = "transparent";
  if (Member.isInChildOrg) {
    if (quest.inheritance === InheritanceStatus.IS_CHILD) {
      tagColor = "#FFA904";
    }
    if (quest.inheritance === InheritanceStatus.NONE) {
      tagColor = "#00CABE";
    }
  }

  const menuMenuClicked = (e: React.MouseEvent) => {
    e.stopPropagation();
    e.preventDefault();

    setShowMenu(!showMenu);
  };

  const editNameClicked = (e: React.MouseEvent) => {
    e.stopPropagation();
    e.preventDefault();

    setNewName(quest.name);
    setShowMenu(!showMenu);
    setIsEditing(!isEditing);
  };

  const saveName = async () => {
    setIsSaving(true);
    let quest = { ...props.quest };
    quest.name = newName;
    await QuestsModel.updateQuest(quest, true);
    setIsSaving(false);
    setIsEditing(false);
  };

  return (
    <div
      className={`BoardQuestItem ${quest.type === QuestType.MATRIX ? "isMatrix" : ""} ${isDragging ? "isDragging" : ""} ${showMenu ? "showMenu" : ""} ${isEditing ? "isEditing" : ""}`}
      ref={provided?.innerRef}
      {...provided?.draggableProps}
      {...provided?.dragHandleProps}
      data-is-dragging={isDragging}
      data-testid={quest.slug}
      data-index={index}
      aria-label={`${quest.name}`}
      onDoubleClick={() => {
        if (isDragging || isEditing) return;

        navigate(`/quest/${quest.slug}`);
      }}
    >
      {isEditing ? (
        <div className="EditView">
          <Input
            containerClassName="mb-3"
            value={newName}
            onChange={(e) => {
              setNewName(e.target.value);
            }}
          />
          <div className="editViewButtons gap-2">
            {isSaving ? (
              <Spinner />
            ) : (
              <>
                <Button onClick={() => setIsEditing(false)}>Cancel</Button>
                <Button color={ButtonColor.ORANGE} onClick={saveName}>
                  Save
                </Button>
              </>
            )}
          </div>
        </div>
      ) : (
        <div className="Wrapper">
          <div className="Tag" style={{ borderLeftColor: tagColor }} />
          <div className="QuestName">
            {/* {String(quest.order || "U")} -  */}
            {quest.name}
          </div>

          {canEditWorkflows && (
            <div className="MenuButton" onClick={menuMenuClicked}>
              {/* id:{quest.slug} - {quest.order} */}
              <BiDotsVerticalRounded size={18} />
              {showMenu && <BoardQuestItemOverflowMenu quest={quest} editNameClicked={editNameClicked} closeMenu={() => setShowMenu(false)} />}
            </div>
          )}
        </div>
      )}
    </div>
  );
}

export default React.memo<Props>(BoardQuestItem);
